var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6038 8.00174H11.2024V1.60035H1.60035V20.8045H17.6038V8.00174ZM16.9412 6.40139L12.8028 2.26299V6.40139H16.9412ZM0.800174 0H12.8028L19.2042 6.40139V21.6047C19.2042 21.8169 19.1199 22.0204 18.9698 22.1705C18.8197 22.3206 18.6162 22.4049 18.404 22.4049H0.800174C0.587955 22.4049 0.384427 22.3206 0.234366 22.1705C0.084304 22.0204 0 21.8169 0 21.6047V0.800174C0 0.587955 0.084304 0.384427 0.234366 0.234366C0.384427 0.0843038 0.587955 0 0.800174 0ZM4.80104 11.2024H14.4031V12.8028H4.80104V11.2024ZM4.80104 6.40139H8.80191V8.00174H4.80104V6.40139ZM4.80104 16.0035H14.4031V17.6038H4.80104V16.0035Z",
    fill: "#88619A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2);
export default __webpack_public_path__ + "static/media/v2.b1b7b63e0856b42ed1011ab85342b38f.svg";
export { ForwardRef as ReactComponent };